import { api } from './api';
import type { RolType } from '@types';

// ============================================
// Rol API Functions
// ============================================

/**
 * Haal alle rolTypes op
 */
export const getRolTypes = async (): Promise<RolType[]> => {
  const response = await api.get<RolType[]>('/rollen/types');
  return response.data;
};
